import React from "react";
import { useTranslation } from "react-i18next";


const Marquee = () => {
  const { t } = useTranslation();
  return (
    <div className="marquee-container" role="region" aria-live="polite" aria-label="Marquee content showcasing dynamic titles">
      <div className="marquee-wrapper">
        <span className="normal-font">{t("marquee.title1")}</span>
        <span className="special-font">{t("marquee.title2")}</span>
        <span className="normal-font">{t("marquee.title3")}</span>
        <span className="special-font">{t("marquee.title4")}</span>
      </div>
      <div className="marquee-wrapper" aria-hidden="true">
      <span className="normal-font">{t("marquee.title1")}</span>
        <span className="special-font">{t("marquee.title2")}</span>
        <span className="normal-font">{t("marquee.title3")}</span>
        <span className="special-font">{t("marquee.title4")}</span>
      </div>
    </div>
  );
};

export default Marquee;
